import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';

const ForgotPassword = () => {
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Autofill email if passed from sign-in page
    if (location.state?.email) {
      setEmail(location.state.email);
    }
  }, [location]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');

    try {
      const response = await axios.post('/api/accounts/password-reset/', {
        email: email
      });

      if (response.data.email_exists) {
        // Email exists - show success message
        setMessage(response.data.message);
        setEmail('');
      } else {
        // Email doesn't exist - show error message
        setError(response.data.message);
      }
    } catch (err) {
      setError(err.response?.data?.email?.[0] || 'An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password-page">
      <div className="container" style={{ maxWidth: '500px', margin: '60px auto', padding: '40px' }}>
        <h1 style={{ textAlign: 'center', marginBottom: '20px' }}>Forgot Password?</h1>
        <p style={{ textAlign: 'center', marginBottom: '30px', color: '#999' }}>
          Enter your email address and we'll send you a link to reset your password.
        </p>

        {message && (
          <div style={{
            backgroundColor: '#e8f5e9',
            color: '#2e7d32',
            padding: '15px',
            borderRadius: '8px',
            marginBottom: '20px',
            textAlign: 'center'
          }}>
            {message}
          </div>
        )}

        {error && (
          <div style={{
            backgroundColor: '#ffebee',
            color: '#c62828',
            padding: '15px',
            borderRadius: '8px',
            marginBottom: '20px',
            textAlign: 'center'
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <input
            type="email"
            placeholder="Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={{
              padding: '15px',
              fontSize: '16px',
              borderRadius: '8px',
              border: '1px solid #ddd'
            }}
          />

          <button
            type="submit"
            disabled={loading}
            style={{
              padding: '15px',
              fontSize: '18px',
              marginTop: '10px',
              width: '60%',
              marginLeft: 'auto',
              marginRight: 'auto',
              display: 'block',
              border: 'none',
              outline: 'none',
              borderRadius: '8px',
              background: loading ? '#ccc' : 'linear-gradient(135deg, var(--pink) 0%, var(--violet) 100%)',
              color: '#fff',
              fontWeight: 'bold',
              cursor: loading ? 'not-allowed' : 'pointer',
              boxShadow: loading ? 'none' : '0 4px 15px rgba(216, 134, 255, 0.4)',
              transition: 'all 0.3s ease',
              textTransform: 'uppercase',
              letterSpacing: '1px',
              textAlign: 'center',
              whiteSpace: 'nowrap',
              boxSizing: 'border-box'
            }}
            onMouseEnter={(e) => {
              if (!loading) {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 6px 20px rgba(216, 134, 255, 0.6)';
              }
            }}
            onMouseLeave={(e) => {
              if (!loading) {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 4px 15px rgba(216, 134, 255, 0.4)';
              }
            }}
          >
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: '30px' }}>
          <Link
            to="/signin"
            style={{
              color: 'var(--pink)',
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: '500'
            }}
          >
            Back to Sign In
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
